import { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { roundTo2Decimals } from 'utils/calcUtils';
import {
  HIDE_PRODUCTION_DELETE_MODAL,
  RESET_RECALCULATED_PRICE_OFFER,
  SET_PRODUCT_TO_DELETE,
  SET_RECALCULATED_PRICE_OFFER,
  START_LOADING,
  STOP_LOADING,
} from '../singlePriceOfferSlice';
import API from 'utils/atolyeAPI';
import alert from 'js/sweetAlert';

const AtolyeAPI = new API();

const DeleteProductModal = ({ fetchPriceOffer }) => {
  //Redux
  const dispatch = useDispatch();
  const { priceOffer, isProductionDeleteModalDisplayed, productToDelete, recalculatedPriceOffer } =
    useSelector((state) => state.priceOffers.singlePriceOffer);

  // Effects
  useEffect(() => {
    recalculatePriceOfferBeforeDelete();
  }, [productToDelete]);

  // Functions
  const deleteProductHandler = async () => {
    dispatch(START_LOADING());
    const body = { ...recalculatedPriceOffer };
    try {
      await AtolyeAPI.post(`/price_offer_products/${productToDelete.id}/delete`, body);
      fetchPriceOffer(priceOffer.id);
      alert('success', 'Ürün silindi');
    } catch (error) {
      console.log(error);
      alert('error', 'Ürün Silinirken Hata Oluştu');
    } finally {
      dispatch(STOP_LOADING());
      dispatch(HIDE_PRODUCTION_DELETE_MODAL());
      dispatch(RESET_RECALCULATED_PRICE_OFFER());
    }
  };

  const recalculatePriceOfferBeforeDelete = () => {
    const productsWithoutDeletingProduct = priceOffer?.products?.filter(
      (product) => product.id !== productToDelete?.id,
    );
    const productsOnlyWithFinancialDataWithoutDeletingProduct = productsWithoutDeletingProduct.map(
      (product) => ({ id: product.id, price: product.price, quantity: product.quantity }),
    );

    const _tempProductsTotal = productsOnlyWithFinancialDataWithoutDeletingProduct.reduce(
      (acc, product) => {
        return acc + parseFloat(product.price * parseInt(product.quantity));
      },
      0,
    );
    const _tempDiscountTotal =
      _tempProductsTotal - _tempProductsTotal / (1 + priceOffer.discountRate / 100);
    const _tempSubTotal = _tempProductsTotal - _tempDiscountTotal;
    const _tempTotal = _tempSubTotal * 1.18;
    const _tempKDVtotal = _tempTotal - _tempSubTotal;

    dispatch(
      SET_RECALCULATED_PRICE_OFFER({
        priceOffers_id: priceOffer.id,
        productsTotal: _tempProductsTotal,
        discountTotal: _tempDiscountTotal,
        subTotal: _tempSubTotal,
        KDVtotal: _tempKDVtotal,
        total: roundTo2Decimals(_tempTotal),
      }),
    );
  };

  const withKdv = (value) => {
    const _tempValue = roundTo2Decimals(value * 1.18);
    return _tempValue.toLocaleString('tr');
  };

  return (
    productToDelete && (
      <Modal
        className="production-details-edit-modal"
        centered
        show={isProductionDeleteModalDisplayed}
        onHide={() => {
          dispatch(HIDE_PRODUCTION_DELETE_MODAL());
          dispatch(SET_PRODUCT_TO_DELETE(null));
        }}>
        <Modal.Header>
          <Modal.Title>Ürünü Sil</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong className="text-danger">{withKdv(productToDelete.total)} ₺</strong> tutarındaki{' '}
            <strong>{productToDelete.products_code}</strong> kodlu{' '}
            <strong>{productToDelete.quantity}</strong> adet{' '}
            <strong>{productToDelete.description}</strong>,{' '}
            <strong>{productToDelete.priceOffers_id}</strong> numaralı fiyat teklifinden
            silinecektir.
          </p>
          <p>Teklif Finansal Bilgileri aşağıdaki şekilde güncellenecektir:</p>
          {recalculatedPriceOffer.priceOffers_id && (
            <table className="table mb-4">
              <thead>
                <tr>
                  <th scope="col">Alan</th>
                  <th scope="col">Tutar/Değer</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>Ürünler Toplamı</strong>
                  </td>
                  <td>{withKdv(recalculatedPriceOffer.productsTotal)} ₺</td>
                </tr>
                <tr>
                  <td>
                    <strong>İskonto Oranı</strong>
                  </td>
                  <td>% {priceOffer.discountRate}</td>
                </tr>
                <tr>
                  <td>
                    <strong>İskonto Tutarı</strong>
                  </td>
                  <td>{withKdv(recalculatedPriceOffer.discountTotal)} ₺</td>
                </tr>
                <tr>
                  <td>
                    <strong>Ara Toplam</strong>
                  </td>
                  <td>{withKdv(recalculatedPriceOffer.subTotal)} ₺</td>
                </tr>
                <tr>
                  <td>
                    <strong>Teklif Toplamı</strong>
                  </td>
                  <td>{recalculatedPriceOffer.total.toLocaleString('tr')} ₺</td>
                </tr>
              </tbody>
            </table>
          )}
          <p className="lead text-danger text-center">
            <strong>Onaylıyor musunuz?</strong>
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            variant="light"
            onClick={() => {
              dispatch(HIDE_PRODUCTION_DELETE_MODAL());
              dispatch(SET_PRODUCT_TO_DELETE(null));
            }}>
            Vazgeç
          </Button>
          <Button variant="danger" className="text-white" onClick={deleteProductHandler}>
            Sil
          </Button>
        </Modal.Footer>
      </Modal>
    )
  );
};

export default DeleteProductModal;
